import { Heading } from "@abb/abb-common-ux-react/components/Heading";
import { Link } from "@abb/abb-common-ux-react/components/Link";
import styled from "styled-components";
import { commonUXTheme } from "styles/commonUXVariables";
import { Button } from "../../../framework/components/Button";

export const FooterBackground = styled.footer<{
  backgroundImage: string;
  backgroundImageWebP: string;
}>`
  &:before {
    content: "";
    position: absolute;
    top: 0px;
    left: 0px;
    width: 100%;
    height: 100%;
    background-image: linear-gradient(90deg, rgba(0, 0, 0, 0) 0%, rgba(255, 255, 255, 1) 70%),
      url(${(props) => props.backgroundImage});
    @supports (
      background-image: -webkit-image-set(url(${(props) => props.backgroundImageWebP}) 1x)
    ) {
      background-image: linear-gradient(90deg, rgba(0, 0, 0, 0) 0%, rgba(255, 255, 255, 1) 70%),
        url(${(props) => props.backgroundImageWebP});
    }
    background-position: 10%;
    background-repeat: no-repeat;
    background-size: cover;
    @media (max-width: ${commonUXTheme.breakpoints.lg}) {
      filter: opacity(0.4);
      background-image: url(${(props) => props.backgroundImage});
      @supports (
        background-image: -webkit-image-set(url(${(props) => props.backgroundImageWebP}) 1x)
      ) {
        background-image: url(${(props) => props.backgroundImageWebP});
      }
    }
  }
  position: relative;
  padding-block: ${commonUXTheme.sizes.xl};
  padding-inline: ${commonUXTheme.sizes.lm};
  flex-grow: 1;
  display: flex;
  flex-direction: column;
  z-index: 0;
`;

// For footer
export const MaxWidthContainer = styled.div<{ maxWidth: number }>`
  max-width: ${(props) => `${props.maxWidth}px`};
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  width: 100%;
  height: 100%;
  margin-left: auto;
  margin-right: auto;
`;

export const FooterHeader = styled(Heading)`
  font-family: ${commonUXTheme.fonts.families.fontAbbBold} !important;
  font-size: ${commonUXTheme.fonts.sizes.fontSizeM} !important;
  line-height: ${commonUXTheme.fonts.lineHeights.lineHeightM} !important;
  margin-bottom: ${commonUXTheme.sizes.s};
`;

export const FooterTop = styled.div`
  display: flex;
  justify-content: space-between;
  @media (max-width: ${commonUXTheme.breakpoints.lg}) {
    flex-direction: column;
    justify-content: center;
  }
`;

export const FooterBottom = styled.div`
  display: flex;
  justify-content: space-evenly;
  @media (max-width: 830px) {
    align-items: center;
    flex-direction: column;
  }
`;

export const FooterTopItem = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
  padding-inline: ${commonUXTheme.sizes.xl};

  &:first-child {
    padding-left: 0;
    padding-right: ${commonUXTheme.sizes.xl};
  }

  &:last-child {
    padding-right: 0;
    padding-left: ${commonUXTheme.sizes.xl};
  }

  @media (max-width: ${commonUXTheme.breakpoints.lg}) {
    &:not(:last-child) {
      margin-bottom: ${commonUXTheme.sizes.xl};
    }
    padding-inline: 0 !important;
  }
`;

export const FooterButton = styled(Button)`
  text-decoration: none !important;
  width: 150px;
  margin-top: auto;
  @media (max-width: ${commonUXTheme.breakpoints.lg}) {
    margin-top: 0px;
  }
`;

export const FooterSplitter = styled.hr`
  border-top-color: ${commonUXTheme.colors.grey30};
  margin: ${commonUXTheme.sizes.l} 0px;
`;

export const DisclaimerText = styled.p`
  font-size: ${commonUXTheme.fonts.sizes.fontSizeS};
  color: ${commonUXTheme.colors.grey60};
`;

export const FooterItem = styled.span`
  @media (max-width: 830px) {
    margin-bottom: ${commonUXTheme.sizes.lm};
  }
`;

export const FooterLink = styled(Link).attrs(() => {
  return {
    discreet: true,
    underlined: false
  };
})`
  @media (max-width: 830px) {
    &:not(:last-child) {
      margin-bottom: ${commonUXTheme.sizes.lm};
    }
  }
`;

// z-index must be higher than FooterBackground z-index to render the content above the background image.
export const FooterContent = styled.div`
  margin: 0px auto;
  z-index: 1;
  width: 100%;
  max-width: ${commonUXTheme.breakpoints.xxl};
`;

export const FooterContainer = styled.div`
  background-color: ${commonUXTheme.colors.grey10};
`;
